import AppRoutes from "./Routes/AppRoutes";

function App() {
  return <AppRoutes />;
}

export default App;